import styled from "styled-components";
import * as palette from "../../SCVariables";

export const JoinForm = styled.form``;

export const EmailInput = styled.input`
  padding: 15px;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  width: 230px;
  flex: 2;
  outline: none;
`;
export const CTAButton = styled.button`
  padding: 15px;
  border: none;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  width: 100px;
  flex: 1;
  background: ${palette.mainOrange};
  color: ${palette.mainBlack};

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${palette.mainOrange};
    color: ${palette.mainWhite};
  }
  :disabled {
    background: #ffcf76;
    color: ${palette.mainBlue};
    cursor: not-allowed;
  }
`;
export const ErrorTag = styled.p`
  font-size: 14px;
  color: ${palette.mainOrange};
  margin-bottom: 10px;
`;

export const JoinFlexContainer = styled.div`
  display: flex;
  width: 495px;

  @media screen and (max-width: 760px) {
    width: 300px;
  }
`;
